import { useEffect, type FC, type ReactNode, type UIEventHandler } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select';

interface SelectElementProps {
  options: Record<string, unknown>[];
  label: string | ReactNode;
  optionLabel?: string;
  defaultValue?: string;
  selectedId?: string | number;
  onChange: (target: unknown) => void;
  idAttribute?: string;
  displayLabelAs?: (label: string) => string;
  className?: string;
  onScroll?: UIEventHandler;
}

const defaultDisplayLabel = (label: string) => label;

const SelectElement: FC<SelectElementProps> = ({
  options,
  label,
  optionLabel = 'name',
  defaultValue,
  selectedId,
  onChange,
  idAttribute = 'id',
  displayLabelAs = defaultDisplayLabel,
  className = '',
  onScroll,
}) => {
  useEffect(() => {
    if (!selectedId && !defaultValue && idAttribute && options.length > 0) {
      const firstOption = options[0];
      if (!!firstOption && typeof firstOption[idAttribute] !== 'undefined') {
        onChange(firstOption[idAttribute] as string);
      }
    }
  }, [options, onChange, idAttribute, selectedId, defaultValue]);

  return (
    <div className={`select-element-container d-flex flex-row ${className}`}>
      <span className="subtitle mr-2">{label}</span>
      <Select
        value={selectedId != null && selectedId !== '' ? String(selectedId) : undefined}
        onValueChange={(value: string) => onChange(value)}
      >
        <SelectTrigger className="connector-select-form $tw-w-auto">
          <SelectValue placeholder={defaultValue ?? ''} />
        </SelectTrigger>
        <SelectContent position="popper" className="$tw-max-h-[300px]" onViewportScroll={onScroll}>
          {options.map((option) => (
            <SelectItem key={String(option[idAttribute])} value={String(option[idAttribute])}>
              {displayLabelAs(String(option[optionLabel]))}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SelectElement;
